import * as React from 'react';
import * as _ from 'lodash-es';
import cx from 'classnames';
import { connectWithRouter } from 'helpers/connectWithRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { getSingle } from 'actions/Companies/GetSingle';
import { getFlags } from 'actions/Companies/GetFlags';
import {
  resetImportEmployees,
  confirmCSVImport,
} from 'actions/Companies/ImportEmployees';
import { getFeatures, resetFeatures } from 'actions/Features/Get';
import { getOrganizationsProductsSettings } from 'actions/Features/GetOrganziationsProductsSettings';
import { getFraudRule } from 'actions/Features/GetFraudCheck';
import { updateOrganizationFraudRule } from 'actions/Features/PutOrganizationFraudRule';
import { putFeatures } from 'actions/Features/Put';
import { getBasicEconomyFeature } from 'actions/Features/GetBasicEconomy';
import { hasPermission } from '../../helpers/Permission';
import { putOrganizationsProductsSettings } from 'actions/Features/PutOrganizaitonsProductsSettings';
import { getReimbursement } from 'actions/Features/GetReimbursement';
import { putReimbursement } from 'actions/Features/PutReimbursement';
import { getReimbursementSettings } from 'actions/Features/GetReimbursementSettings';
import { putReimbursementSettings } from 'actions/Features/PutReimbursementSettings';
import { putBasicEconomy } from 'actions/Features/PutBasicEconomy';
import { getCorporateRateCodes } from 'actions/Companies/Settings/GetCorporateRateCodes';
import { getFlightTourCodes } from 'actions/Companies/Settings/GetFlightTourCodes';
import { getNegotiatedHotels } from 'actions/Companies/GetNegotiatedHotels';
import { getActiveExpenseIntegration } from 'actions/Companies/GetActiveExpenseIntegration';
import { getAgencySetting } from 'actions/Companies/Settings/GetAgencySetting';
import { putCorporateRateCodes } from '../../actions/Companies/Settings/PutCorporateRateCodes';
import { getActiveExpenseManagenentIntegration } from 'actions/Companies/GetActiveExpenseManagement';
import { getDefaultExpensePolicy } from 'actions/Companies/GetDefaultExpensePolicy';
import { getCarLoyaltyProgram } from '../../actions/LoyaltyPrograms/GetCarLoyaltyProgram';
import { NavigateFunction } from 'react-router-dom';
import { getBankAccount } from 'actions/Companies/GetBankAccount';
import { getFlightBookingWindowFeature } from 'actions/Features/GetFlightBookingWindow';
import { deleteFlightBookingFeature } from 'actions/Features/DeleteFlightBookingWindow';
import { putFlightBookingFeature } from 'actions/Features/PutFlightBookingWindow';
import { getExpenseSplitSetting } from 'actions/Companies/Settings/GetExpenseSplitSetting';
import { putExpenseSplitSetting } from 'actions/Companies/Settings/PutExpenseSplitSetting';
import { putVerifiedForTravelSettings } from 'actions/Features/PutVerifiedForTravelSettings';
import { getVerifiedForTravelSettings } from 'actions/Features/GetVerifiedForTravelSettings';
import { getSpecialRateCodes } from 'actions/Companies/Settings/GetSpecialRateCodes';
import { getCarbonEmissionProducts } from 'actions/Companies/Settings/GetCarbonEmissionProducts';
import { addUpdateCarbonEmissionProduct } from 'actions/Companies/Settings/AddUpdateCarbonEmissionProduct';
import { getCarbonEmissionOrgProduct } from 'actions/Companies/Settings/GetCarbonEmissionOrgProduct';
import { getPaidPlanSetting } from 'actions/Companies/Settings/GetPaidPlan';
import { getCRCPoints } from 'actions/Companies/Settings/getCRCPoints';
import { postCRCPoints } from 'actions/Companies/Settings/postCRCPoints';
import { deactivateCompany } from 'actions/Companies/DeactivateCompany';
import { reactivateCompany } from 'actions/Companies/ReactivateCompany';

import {
  discardTransactions,
  getTransactions,
  restoreTransactions,
} from 'actions/Companies/Transactions';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LayoutDashboard from 'components/Layout/Dashboard';
import CompanyInfo from 'components/CompanyDetails/CompanyInfo';
import AdditionalDomains from 'components/CompanyDetails/AdditionalDomains/AdditionalDomains';
import OrganizationAgencySetting from 'components/CompanyDetails/OrganizationAgencySetting';
import CompanyFeatures from 'components/Features/Features';
import Reimbursements from 'components/Features/Reimbursements';
import BetaFeatures from 'components/Features/BetaFeatures';
import TravelFeatures from 'components/Features/TravelFeatures';
import EmployeeList from 'components/CompanyDetails/EmployeeList';
import CorporateCards from 'components/CompanyDetails/CorporateCards/CorporateCards';
import Loader from 'components/Loader/Loader';
import CorporateRateCodes from 'components/CorporateRateCodes/CorporateRateCodes';
import NegotiatedSuppliers from 'components/NegotiatedSuppliers/NegotiatedSuppliers';
import ActiveExpenseIntegration from 'components/CompanyDetails/ActiveExpenseIntegration';
import ImportEmployeesPopup from 'components/Popup/ImportEmployeesPopup';
import ImportEmployeesUpload from 'components/ImportEmployees/Upload';
import ImportEmployeesLoading from 'components/ImportEmployees/Loading';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import Breadcrumb from 'components/Breadcrumbs/Breadcrumb';
import CreateUpdateCarbonEmissionProduct from 'components/CreateUpdateCarbonEmissionProduct/CreateUpdateCarbonEmissionProduct';
import { CarbonOffsetReduxState } from 'reducers/CarbonEmissionProducts';
import Notes from 'components/Notes/Notes';

import TransactionsList from 'components/TransactionsList/TransactionsList';
import OrgExpenseReportsTable from 'components/CompanyDetails/OrgExpenseReportsTable';
const styles = require('./styles.pcss');

import { TB_BLACKBOX_ENV } from '../../configs/Api';

import { ReduxState, Company as CompanyType, Features } from 'reducers/types';
import RewardsProgram from 'components/CompanyDetails/CommercialRewards/RewardsProgram';
import isFeatureEnabled, { ScopeType } from '../../helpers/isFeatureEnabled';
import Button from '@mui/material/Button';
import ConfirmationPopup from 'components/Popup/Confirmation';
import MissingTransactionTool from '../../components/MissingTransactionsTool/MissingTransactionTool';
import { PermissionTypes } from '../../constants';
import IntegrationsDisplay from 'components/CompanyDetails/IntegrationsDisplay';
import SupportTools from 'components/SupportTools';
import KycStatusChip from 'components/CompanyDetails/KycStatusChip';
import PlansSection from 'components/CompanyDetails/Plans/PlansSection';

interface RouteParams {
  companyId?: string;
}

type Props = {
  path: string;
  companyId: string;
  getSingle: Function;
  putFeatures: Function;
  companyDetails: CompanyType;
  crcPoints: number;
  importEmployees: any;
  resetImportEmployees: Function;
  confirmCSVImport: Function;
  isLoading: any;
  getFeatures: Function;
  getOrganizationsProductsSettings: Function;
  getBasicEconomyFeature: Function;
  getCorporateRateCodes: Function;
  getFlightTourCodes: Function;
  putOrganizationsProductsSettings: Function;
  getReimbursement: Function;
  putReimbursement: Function;
  resetFeatures: Function;
  features: Array<Features>;
  organziationProductsSettings?: any;
  basicEconomyFeature?: any;
  reimbursementFeature?: any;
  advancedFlightBookingFeature?: any;
  reimbursementSettings?: any;
  corporateRateCodes?: any;
  carbonEmissionOffset: CarbonOffsetReduxState;
  microDepositSetting?: any;
  getNegotiatedHotels: Function;
  getActiveExpenseIntegration: Function;
  updateOrganizationFraudRule: Function;
  getFraudRule: Function;
  getReimbursementSettings: Function;
  putReimbursementSettings: Function;
  putBasicEconomy: Function;
  organizationActiveExpenseIntegration: any;
  getAgencySetting: Function;
  agencySetting?: any;
  putCorporateRateCodes: Function;
  getActiveExpenseManagenentIntegration: Function;
  organizationActiveExpenseManagement: any;
  getDefaultExpensePolicy: any;
  expensePolicy: any;
  getCarLoyaltyProgram: Function;
  carLoyaltyProgram: any;
  getBankAccount: any;
  organizationBankAccount: any;
  getFlightBookingWindowFeature: Function;
  deleteFlightBookingFeature: Function;
  putFlightBookingFeature: Function;
  putExpenseSplitSetting: Function;
  getExpenseSplitSetting: Function;
  verifiedForTravelFeature: Function;
  putVerifiedForTravelSettings: Function;
  getVerifiedForTravelSettings: Function;
  getSpecialRateCodes: Function;
  getCarbonEmissionProducts: Function;
  addUpdateCarbonEmissionProduct: Function;
  getCarbonEmissionOrgProduct: Function;
  specialRateCodes?: any;
  isFeatureFlagsLoading: boolean;
  isFeatureFlagsSuccess: boolean;
  getPaidPlanSetting: Function;
  getCRCPoints: Function;
  postCRCPoints: Function;
  deactivateCompany: Function;
  reactivateCompany: Function;
  getTransactions: Function;
  discardTransactions: Function;
  restoreTransactions: Function;
  transactions?: any;
  companyFlags: Record<string, boolean> | null;
  getFlags: Function;
  navigate: NavigateFunction;
  params: RouteParams;
};

type State = {
  importEmployeesPopupOpen: boolean;
  tabValue: string;
  openConfirmationPopup: boolean;
  buttonText: string;
  popupText: string;
};

class CompanyDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      tabValue: 'profile',
      importEmployeesPopupOpen: false,
      openConfirmationPopup: false,
      buttonText: '',
      popupText: '',
    };

    this.onClickImportEmployees = this.onClickImportEmployees.bind(this);
    this.closeImportEmployeesPopup = this.closeImportEmployeesPopup.bind(this);
    this.props.getCarLoyaltyProgram();
  }

  companyId = this.props.params?.companyId;

  navigate = (path: string) => {
    this.props.navigate(path);
  };

  componentDidMount() {
    let param: any = {};

    if (TB_BLACKBOX_ENV === 'production') {
      param.confidence = 'production';
    }

    this.props.getFeatures(param);
    this.props.getExpenseSplitSetting(this.companyId);
    this.props.getOrganizationsProductsSettings(this.companyId);
    this.props.getBasicEconomyFeature(this.companyId);
    this.props.getFraudRule(this.companyId);
    this.props.getReimbursement(this.companyId);
    this.props.getCorporateRateCodes(this.companyId);
    this.props.getFlightTourCodes(this.companyId);
    this.props.getNegotiatedHotels(this.companyId);
    this.props.getActiveExpenseIntegration(this.companyId);
    this.props.getActiveExpenseManagenentIntegration(this.companyId);
    this.props.getSingle(this.companyId, this.props.navigate);
    this.props.getReimbursementSettings(this.companyId);
    this.props.getBasicEconomyFeature(this.companyId);
    this.props.getAgencySetting(this.companyId);
    this.props.getDefaultExpensePolicy(this.companyId);
    this.props.getBankAccount(this.companyId);
    this.props.getFlightBookingWindowFeature(this.companyId);
    this.props.getVerifiedForTravelSettings(this.companyId);
    this.props.getSpecialRateCodes(this.companyId);
    this.props.getCarbonEmissionOrgProduct(this.companyId);
    this.props.getCarbonEmissionProducts();
    this.props.getPaidPlanSetting(this.companyId);
    this.props.getCRCPoints(this.companyId);
    this.props.getTransactions(this.companyId);
    this.props.getFlags(this.companyId);
  }

  componentWillUnmount() {
    this.props.resetFeatures();
  }

  onClickImportEmployees() {
    this.setState({
      importEmployeesPopupOpen: !this.state.importEmployeesPopupOpen,
    });
  }

  closeImportEmployeesPopup() {
    this.props.resetImportEmployees();

    this.setState({
      importEmployeesPopupOpen: false,
    });
  }

  renderEmployees() {
    return (
      <EmployeeList
        onClickImportEmployees={this.onClickImportEmployees}
        departments={_.get(this.props.companyDetails, 'departments', [])}
        travelPolicies={_.get(this.props.companyDetails, 'travelPolicies', [])}
        expensePolicies={_.get(
          this.props.companyDetails,
          'expensePolicies',
          [],
        )}
        organizationId={this.companyId}
      />
    );
  }

  renderImportEmployeesPopup() {
    if (this.state.importEmployeesPopupOpen === false) {
      return null;
    }

    let content = <ImportEmployeesLoading />;
    if (this.props.importEmployees.validating === false) {
      if (this.props.importEmployees.validationReport === null) {
        content = <ImportEmployeesUpload />;
      } else {
        this.navigate(
          `/company/${this.props.companyDetails.id}/import-employees/`,
        );
      }
    }

    return (
      <ImportEmployeesPopup
        popupOpen={this.state.importEmployeesPopupOpen}
        onClosePopup={this.closeImportEmployeesPopup}
        content={content}
      />
    );
  }

  handleTabChange = (event: any, value: any) => {
    this.setState({
      tabValue: value,
    });
  };

  handleFeatureChange = (feature: any, checked: boolean) => {
    let param = {
      organizationId: this.companyId,
      featureName: feature.name,
      confidence: feature.confidence,
      enabled: checked,
    };
    this.props.putFeatures(param);
  };

  handleBasicEconomyChange = (event: any) => {
    let param = {
      organizationId: this.companyId,
      enabled: !_.get(
        this.props,
        'basicEconomyFeature.feature.value.enabled',
        false,
      ),
    };

    this.props.putBasicEconomy(param);
  };

  handleFlightBookingWindowFeatureChange = (value: any, enabled: any) => {
    const advancedFlightFeature = _.get(
      this.props,
      'advancedFlightBookingFeature.id',
      '',
    );

    if (value && enabled) {
      this.props.putFlightBookingFeature({
        organizationId: this.companyId,
        value: value,
      });
    }

    if (advancedFlightFeature && !enabled) {
      this.props.deleteFlightBookingFeature(advancedFlightFeature);
    }
  };

  handleProductsOrganizationSettingsChange = (product: string) => {
    let param = {
      organizationId: this.companyId,
      settingId: _.get(this.props, 'organziationProductsSettings.id', ''),
      enabled: !_.includes(
        _.get(this.props, 'organziationProductsSettings.value', []),
        product,
      ),
      product,
    };

    this.props.putOrganizationsProductsSettings(param);
  };

  handleFraudRuleChange = (event: any) => {
    let param = {
      orgId: this.companyId,
      rule: event.target.value,
      primaryDomain: this.props.companyDetails.primaryDomain,
    };

    this.props.updateOrganizationFraudRule(param);
  };

  handleReimbursementScheduleChange = (event: any) => {
    const param = {
      frequency: event.target.value,
      organizationId: this.companyId,
    };

    this.props.putReimbursementSettings(param);
  };

  handleTrustedCompanyChange = (event: any) => {
    let param = {
      organizationId: this.companyId,
      settingId: _.get(this.props, 'reimbursementFeature.id', ''),
      enabled: !_.get(this.props, 'reimbursementFeature.value.trusted', false),
    };

    this.props.putReimbursement(param);
  };

  handleExpenseSplitChange = (event: any) => {
    const enabled = !_.get(
      this.props,
      'expenseSplitFeature.feature.value.enabled',
      false,
    );

    this.props.putExpenseSplitSetting(this.companyId, enabled);
  };

  handleVerifiedForTravelChange = () => {
    this.props.putVerifiedForTravelSettings({
      organizationId: this.companyId,
      enabled: !_.get(
        this.props,
        'verifiedForTravelFeature.value.enabled',
        false,
      ),
    });
  };

  renderFeatures = () => {
    const organziationProductsSettings = _.get(
      this.props,
      'organziationProductsSettings',
      [],
    );
    const trustedCompanyFeature = _.get(this.props, 'reimbursementFeature', []);

    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <CompanyFeatures
            expenseSplitFeature={_.get(
              this.props,
              'expenseSplitFeature.feature',
              {},
            )}
            handleExpenseSplitChange={this.handleExpenseSplitChange}
            isLoadingExpenseSplit={_.get(
              this.props,
              'expenseSplitFeature.isLoading',
              false,
            )}
            organziationProductsSettings={organziationProductsSettings}
            handleProductSettingsChange={() =>
              this.handleProductsOrganizationSettingsChange('expenses')
            }
          />

          <Reimbursements
            trustedCompanyFeature={trustedCompanyFeature}
            handleTrustedCompanyChange={this.handleTrustedCompanyChange}
            organizationName={_.get(this.props, 'companyDetails.name', '')}
            handleReimbursementScheduleChange={
              this.handleReimbursementScheduleChange
            }
            reimbursement={_.get(this.props, 'reimbursementSettings', {})}
            organizationBankAccount={_.get(
              this.props,
              'organizationBankAccount',
              {},
            )}
            organizationId={this.companyId}
            companyFlags={this.props.companyFlags}
          />
          {hasPermission('expenseReport', PermissionTypes.read) && (
              <OrgExpenseReportsTable organizationId={this.companyId || ''} />
            )}
        </div>
        <div className={styles.sidebar}>
          {(_.get(
            this.props.organizationActiveExpenseIntegration,
            'provider',
            null,
          ) !== null ||
            _.get(
              this.props.organizationActiveExpenseManagement,
              'value',
              null,
            ) !== null) && (
            <ActiveExpenseIntegration
              provider={_.get(
                this.props.organizationActiveExpenseIntegration,
                'provider',
                '',
              )}
              expenseManagement={_.get(
                this.props.organizationActiveExpenseManagement,
                'value',
                [],
              )}
            />
          )}
        </div>
      </div>
    );
  };

  renderCreditCards = () => {
    return (
      <CorporateCards
        creditCards={_.get(this.props.companyDetails, 'creditCards', [])}
        organizationId={this.props.companyDetails.id}
        departments={_.get(this.props.companyDetails, 'departments', [])}
        onSaveCreditCard={this.handleCreditCardSaved}
        users={_.get(this.props.companyDetails, 'employees', [])}
        organizationName={_.get(this.props, 'companyDetails.name', '')}
      />
    );
  };

  renderBeta = () => {
    const features = _.get(this.props, 'features', []);
    return (
      <BetaFeatures
        features={features}
        organizationId={this.props.companyDetails.id}
        type="organization"
        onHandleChange={this.handleFeatureChange}
      />
    );
  };

  updateCarbonEmissionProduct = async (data: any) => {
    const { addUpdateCarbonEmissionProduct: onUpdateCarbonEmissionProduct } =
      this.props;

    await onUpdateCarbonEmissionProduct(this.companyId, data);
  };

  renderCarbonEmissionProduct = () => {
    const {
      carbonEmissionOffset: {
        isLoading,
        productId = '',
        carbonOffsetProducts = [],
      },
    } = this.props || {};

    return (
      <CreateUpdateCarbonEmissionProduct
        isLoading={isLoading}
        productId={productId}
        products={carbonOffsetProducts}
        onUpdateCarbonEmissionProduct={this.updateCarbonEmissionProduct}
      />
    );
  };

  renderCorporateRateCodes = () => {
    return (
      <CorporateRateCodes
        putCorporateCodes={this.putCorporateRateCodes}
        flightCodes={_.get(
          this.props.corporateRateCodes,
          'corporateRateCodes.value.flights',
          [],
        )}
        carCodes={_.get(
          this.props.corporateRateCodes,
          'corporateRateCodes.value.cars',
          [],
        )}
        hotelCodes={_.get(
          this.props.corporateRateCodes,
          'corporateRateCodes.value.hotels',
          [],
        )}
        isLoading={_.get(this.props.corporateRateCodes, 'isLoading', false)}
        hasPermission={hasPermission('organizations', PermissionTypes.update)}
        organization={true}
        carLoyaltyProgram={this.props.carLoyaltyProgram}
      />
    );
  };

  putCorporateRateCodes = (params: any) => {
    params.organizationId = this.props.companyDetails.id;
    params.settingId = _.get(
      this.props.corporateRateCodes,
      'corporateRateCodes.id',
      '',
    );

    this.props.putCorporateRateCodes(params);
  };

  renderNegotiatedSuppliers = () => {
    return <NegotiatedSuppliers />;
  };

  renderNotes = () => {
    return (
      <Notes
        id={this.companyId}
        type="organization"
        entity={this.props.companyDetails}
      />
    );
  };

  renderTravelFeatures = () => {
    const organziationProductsSettings = _.get(
      this.props,
      'organziationProductsSettings',
      [],
    );

    return (
      <TravelFeatures
        handleFraudRuleChange={this.handleFraudRuleChange}
        fraudCheck={_.get(this.props, 'fraudCheck', 'fraud')}
        basicEconomyFeature={_.get(
          this.props,
          'basicEconomyFeature.feature',
          {},
        )}
        advancedFlightFeature={_.get(
          this.props,
          'advancedFlightBookingFeature',
          '',
        )}
        verifiedForTravelFeature={_.get(
          this.props,
          'verifiedForTravelFeature',
          '',
        )}
        organziationProductsSettings={organziationProductsSettings}
        handleBasicEconomyChange={this.handleBasicEconomyChange}
        handleVerifiedForTravelChange={this.handleVerifiedForTravelChange}
        handleFlightBookingWindowFeatureChange={
          this.handleFlightBookingWindowFeatureChange
        }
        handleProductSettingsChange={() =>
          this.handleProductsOrganizationSettingsChange('travel')
        }
      />
    );
  };

  renderOrgAgency = () => {
    return (
      <OrganizationAgencySetting
        agencyDetails={this.props.agencySetting}
        specialRateCodes={this.props.specialRateCodes}
        agency={_.get(this.props.companyDetails, 'agency', {})}
        organizationId={this.companyId}
      />
    );
  };

  renderCompanyData = () => {
    return (
      <TransactionsList
        transactions={_.get(this.props, 'transactions.transactions', [])}
        organizationId={this.companyId}
        refreshTransactions={this.props.getTransactions}
        discardTransactions={this.props.discardTransactions}
        restoreTransactions={this.props.restoreTransactions}
      />
    );
  };

  handleCreditCardSaved = () => {
    this.props.getSingle(this.companyId, this.props.navigate);
  };

  renderBrexCustomer = () => {
    let isBrexcustomer = false;

    _.forEach(_.get(this.props, 'companyDetails.employees', []), (e: any) => {
      if (_.get(e, '_meta.brex', null) !== null) {
        isBrexcustomer = true;
        return false;
      }

      return;
    });

    return isBrexcustomer;
  };

  onPostCRCPoints = (points: number) => {
    // @NOTE: If not adding or subtracting points, returning early
    if (!points) {
      return;
    }
    if (points < 0 && Math.abs(points) > this.props.crcPoints) {
      throw new Error(
        'Insufficient balance: cannot subtract more than the current balance.',
      );
    }
    this.props.postCRCPoints(this.companyId, points);
  };

  renderTab = () => {
    switch (this.state.tabValue) {
      case 'profile':
        return (
          <div className={styles.container}>
            <div className={styles.content}>
              <CompanyInfo
                company={this.props.companyDetails}
                disabled={
                  !hasPermission('organizations', PermissionTypes.update)
                }
              />
              <AdditionalDomains
                company={this.props.companyDetails}
                hasPermission={hasPermission(
                  'organizations',
                  PermissionTypes.update,
                )}
              />
              {this.renderCreditCards()}
              {hasPermission('organizations', PermissionTypes.update) && (
                <IntegrationsDisplay
                  organizationId={this.companyId}
                  organizationName={_.get(
                    this.props,
                    'companyDetails.name',
                    '',
                  )}
                />
              )}
            </div>
          </div>
        );
        break;
      case 'plans':
        return (
          <div>
            <PlansSection company={this.props.companyDetails} />
            {this.renderRewardsProgram()}
          </div>
        );
        break;
      case 'expenses':
        return (
          <div>
            {this.renderFeatures()}
          </div>
        );
        break;
      case 'travel':
        return (
          <div>
            {this.renderOrgAgency()}
            {this.renderTravelFeatures()}
            {this.renderCorporateRateCodes()}
            {this.renderCarbonEmissionProduct()}
            {this.renderNegotiatedSuppliers()}
            {this.renderNotes()}
          </div>
        );
        break;
      case 'beta':
        return <div>{this.renderBeta()}</div>;
        break;
      case 'companyData':
        return <div>{this.renderCompanyData()}</div>;
        break;
      case 'findTransaction':
        return (
          <div>
            <MissingTransactionTool orgId={this.companyId} />
          </div>
        );
      case 'supportTools':
        return (
          <div>
            <SupportTools organizationId={this.companyId || ''} />
          </div>
        );
      default:
        return (
          <div>
            {this.renderEmployees()}
            {this.renderImportEmployeesPopup()}
          </div>
        );
        break;
    }
  };

  renderRewardsProgram = () => {
    let isCommercialRewardsEnabled = false;

    if (
      this.props.isFeatureFlagsLoading === false &&
      this.props.isFeatureFlagsSuccess === true &&
      this.props.companyDetails.agency?.id
    ) {
      const featureFlag = this.props.features.find(
        (flag) => flag.name === 'commercialRewards',
      );

      if (!featureFlag) {
        return null;
      }

      isCommercialRewardsEnabled = isFeatureEnabled(
        featureFlag,
        ScopeType.AGENCY,
        this.props.companyDetails.agency?.id,
      );

      if (isCommercialRewardsEnabled === false) {
        return null;
      }

      return (
        <div>
          <RewardsProgram></RewardsProgram>
          {/* <CRCPoints
            crcPoints={this.props.crcPoints}
            onPostCRCPoints={this.onPostCRCPoints}
          /> */}
        </div>
      );
    }

    return null;
  };

  renderCompanyStatus = () => {
    if (_.get(this.props, 'companyDetails.status', '') === 'disabled') {
      return <div className={styles.labelStatusDisabled}>Terminated</div>;
    }
    return;
  };

  renderDeactivateButton = () => {
    if (
      hasPermission('organizations', PermissionTypes.update) &&
      this.state.tabValue === 'profile'
    ) {
      if (_.get(this.props, 'companyDetails.status', '') === 'disabled') {
        return (
          <div className={styles.reactivateCompanyButtonContainer}>
            <Button
              size="small"
              className={styles.buttonReactivateCompany}
              variant="contained"
              onClick={this.handleReactivateClick}
            >
              Reactivate Company
            </Button>
          </div>
        );
      } else {
        return (
          <div className={styles.deactivateCompanyButtonContainer}>
            <Button
              size="small"
              className={styles.buttonDeactivateCompany}
              variant="contained"
              onClick={this.handleDeactivateClick}
            >
              Deactivate Company
            </Button>
          </div>
        );
      }
    }
    return;
  };

  handleDeactivateClick = () => {
    this.changeStatus();
  };

  handleReactivateClick = () => {
    this.changeStatus();
  };

  changeStatus = () => {
    if (_.get(this.props, 'companyDetails.status', '') === 'disabled') {
      this.setState({
        openConfirmationPopup: true,
        buttonText: 'Reactivate',
        popupText: 'Are you sure you want to reactivate?',
      });
    } else {
      this.setState({
        openConfirmationPopup: true,
        buttonText: 'Deactivate',
        popupText: 'Are you sure you want to deactivate?',
      });
    }
  };

  closePopup = () => {
    this.setState({
      openConfirmationPopup: false,
    });
  };

  onSubmitPopup = () => {
    if (_.get(this.props, 'companyDetails.status', '') === 'disabled') {
      this.props.reactivateCompany(this.companyId);
    } else {
      this.props.deactivateCompany(this.companyId);
    }
    this.setState({
      openConfirmationPopup: false,
    });
  };

  render() {
    if (this.props.isLoading) {
      return (
        <LayoutDashboard>
          <div className="pageWrapper">
            <Loader
              visible={this.props.isLoading}
              id="companyLoader"
            />
          </div>
        </LayoutDashboard>
      );
    }

    return (
      <LayoutDashboard>
        <div>
          <Breadcrumbs className={styles.breadcrumbs}>
            <Breadcrumb
              name="Lookup"
              arrow
            />
            <Breadcrumb name={_.get(this.props, 'companyDetails.name', '')} />
          </Breadcrumbs>
        </div>

        <div className="pageWrapper pageWrapperMid">
          <div className={styles.companyNameContainer}>
            <h1>{_.get(this.props, 'companyDetails.name', '')}</h1>

            <div className={styles.chips}>
              {_.get(this.props.companyDetails, 'agency.friendlyName', null) !==
                null && (
                <div
                  style={{
                    background: _.get(
                      this.props.companyDetails,
                      'agency.uiSettings.primaryColor',
                      '#6d717a',
                    ),
                  }}
                  className={styles.agency}
                >
                  {this.props.companyDetails.agency.friendlyName}
                </div>
              )}
              {this.renderCompanyStatus()}

              {this.renderBrexCustomer() && (
                <div className={styles.brex}>Brex</div>
              )}
              {_.get(this.props, 'fraudCheck') === 'emailDomainBlockList' && (
                <div className={styles.fraud}>Fraud</div>
              )}
              <KycStatusChip flags={this.props.companyFlags} />
            </div>
          </div>
          <Tabs
            value={this.state.tabValue}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.handleTabChange}
            className={cx(styles.tabs, styles.loyalityTabs)}
          >
            <Tab
              disableRipple
              className={styles.tab}
              label="Profile"
              value="profile"
            />
            <Tab
              disableRipple
              className={styles.tab}
              label="Plans"
              value="plans"
            />
            <Tab
              disableRipple
              className={styles.tab}
              label="Beta"
              value="beta"
            />
            <Tab
              disableRipple
              className={styles.tab}
              label="Expenses"
              value="expenses"
            />
            <Tab
              disableRipple
              className={styles.tab}
              label="Travel"
              value="travel"
            />
            <Tab
              disableRipple
              className={styles.tab}
              label="Employees"
              value="employees"
              id="employeeTab"
            />
            {hasPermission('syncedTransactions', PermissionTypes.update) && (
              <Tab
                disableRipple
                className={styles.tab}
                label="Company Data"
                value="companyData"
                id="companyTab"
              />
            )}
            {hasPermission('syncedTransactions', PermissionTypes.update) &&
              false && (
                <Tab
                  disableRipple
                  className={styles.tab}
                  label="Find Transaction"
                  value="findTransaction"
                  id="transactionToolTab"
                />
              )}
            {hasPermission('organizations', PermissionTypes.update) && (
              <Tab
                disableRipple
                className={styles.tab}
                label="Support Tools"
                value="supportTools"
                id="supportToolsTab"
              />
            )}
          </Tabs>
          {this.renderTab()}

          {this.renderDeactivateButton()}
          <ConfirmationPopup
            open={this.state.openConfirmationPopup}
            onClose={this.closePopup}
            onSubmit={this.onSubmitPopup}
            title="Are you sure?"
            bodyText={this.state.popupText}
            submitButtonText={this.state.buttonText}
            closeButtonText="Cancel"
          />
        </div>
      </LayoutDashboard>
    );
  }
}

function mapStateToProps(state: ReduxState) {
  return {
    importEmployees: state.importEmployees,
    companyDetails: state.company.company,
    isLoading: state.company.isLoading,
    features: state.betaFeatures.features,
    isFeatureFlagsLoading: state.features.isLoading,
    isFeatureFlagsSuccess: state.features.success,
    updateSuccess: state.betaFeatures.success,
    expenseSplitFeature: state.expenseSplitSetting,
    organziationProductsSettings: state.organizationProductsSettings.products,
    reimbursementFeature: state.organizationTrustedCompanyFeature.feature,
    reimbursementSettings: state.reimbursementSettings.feature,
    corporateRateCodes: state.corporateRateCodes,
    fraudCheck: state.organizationFraudRule.rule,
    basicEconomyFeature: state.organizationBasicEconomyFeature,
    organizationActiveExpenseIntegration:
      state.organizationActiveExpenseIntegration,
    agencySetting: state.agencySetting.agencySetting,
    organizationActiveExpenseManagement:
      state.organizationActiveExpenseManagement,
    expensePolicy: state.expensePolicy.expensePolicy,
    carLoyaltyProgram: state.carLoyaltyPrograms.carLoyaltyProgram,
    organizationBankAccount: state.organizationBankAccount.bankAccount,
    advancedFlightBookingFeature:
      state.organizationFlightBookingWindowFeature.feature,
    verifiedForTravelFeature: state.verifiedForTravelFeature.feature,
    specialRateCodes: state.specialRateCodes.specialRateCodes,
    carbonEmissionOffset: state.carbonEmissionOffset,
    crcPoints: state.CRCPoints.crcPoints,
    isCRCPointsLoading: state.CRCPoints.isLoading,
    transactions: state.transactions,
    companyFlags: state.company.flags,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getSingle,
      resetImportEmployees,
      confirmCSVImport,
      getFeatures,
      getExpenseSplitSetting,
      putExpenseSplitSetting,
      getOrganizationsProductsSettings,
      getBasicEconomyFeature,
      putBasicEconomy,
      putOrganizationsProductsSettings,
      getReimbursement,
      putReimbursement,
      getReimbursementSettings,
      putReimbursementSettings,
      getCorporateRateCodes,
      getFlightTourCodes,
      getNegotiatedHotels,
      getActiveExpenseIntegration,
      getActiveExpenseManagenentIntegration,
      resetFeatures,
      putFeatures,
      getFraudRule,
      updateOrganizationFraudRule,
      getAgencySetting,
      putCorporateRateCodes,
      getDefaultExpensePolicy,
      getCarLoyaltyProgram,
      getBankAccount,
      getFlightBookingWindowFeature,
      deleteFlightBookingFeature,
      putFlightBookingFeature,
      putVerifiedForTravelSettings,
      getVerifiedForTravelSettings,
      getSpecialRateCodes,
      getCarbonEmissionProducts,
      getCarbonEmissionOrgProduct,
      addUpdateCarbonEmissionProduct,
      getPaidPlanSetting,
      getCRCPoints,
      postCRCPoints,
      deactivateCompany,
      reactivateCompany,
      getTransactions,
      discardTransactions,
      restoreTransactions,
      getFlags,
    },
    dispatch,
  );
}

export default connectWithRouter(
  mapStateToProps,
  mapDispatchToProps,
)(CompanyDetails);
